import { Link } from 'react-router-dom';
import { Loesungen } from './Loesungen';
import { Bericht } from './Bericht';
import { ContentSection } from '../../muster';

/**
 * Der Reiter „Auswertung" (Batch 7) — Lösungen (Quoten je Lösungsart und
 * Gewerkpaar, Automatik-Freigaben), Bericht, und Verweise auf die
 * bestehenden Tagesbericht-/Projektleitungs-Seiten.
 *
 * --- Abweichung, hier bewusst -----------------------------------------
 *
 * Der Auftrag nennt „Tagesbericht-/Projektleitungs-Kennzahlen (vorhandene
 * Endpunkte)". Beide haben bereits EIGENE, ausgebaute Seiten
 * (`/koordination/nachtlauf`, `/koordination/projektleitung`) mit eigenem
 * Zustand und eigenen Ladeeffekten. Ihre Daten hier zusätzlich zu laden und
 * anzuzeigen wäre entweder eine dritte Kopie derselben Anzeige oder ein
 * Verweis, der beim nächsten Umbau der Zielseite veraltet. Diese Karte
 * verweist deshalb dorthin, statt die Kennzahlen zu duplizieren.
 */
export function Auswertung({
  loesungen, ableitetLaeuft, onAbleiten, fehler,
  bericht,
}: {
  loesungen: any;
  ableitetLaeuft: boolean;
  onAbleiten: () => void;
  fehler?: string;
  bericht: any;
}) {
  return (
    <>
      <Loesungen
        loesungen={loesungen}
        ableitetLaeuft={ableitetLaeuft}
        onAbleiten={onAbleiten}
        fehler={fehler}
      />

      <Bericht bericht={bericht} />

      <ContentSection
        titel="Weitere Kennzahlen"
        beschreibung={'Tagesbericht und Projektleitung haben eigene Seiten mit eigenem '
          + 'Zustand. Diese Karte verweist dorthin, statt die Kennzahlen ein drittes '
          + 'Mal anzuzeigen.'}
      >
        <div style={{ display: 'flex', gap: 10 }}>
          <Link to="nachtlauf" className="m-knopf" style={{ textDecoration: 'none' }}>
            Tagesbericht (Nachtlauf)
          </Link>
          <Link to="projektleitung" className="m-knopf" style={{ textDecoration: 'none' }}>
            Projektleitung
          </Link>
        </div>
      </ContentSection>
    </>
  );
}
